import { Box, Button, TextField } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const ModalBody = styled(Box)`
    position: absolute;
    width: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    & tbody {
        display: block;
        height: 512px;
        overflow: auto;
    }

    & thead, tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
    }
`

export const EditQtyPerBoxField = styled(TextField)`
    width: 30%;

    & legend {
        display: none;
    }

    & fieldset {
        top: 0;
    }
`

export const SaveUpdatesButton = styled(Button)`
    color: ${theme.colors.green2} !important;
    border-color: ${theme.colors.green2} !important;
`

export const CancelUpdatesButton = styled(Button)`
    color: ${theme.colors.red2} !important;
    border-color: ${theme.colors.red2} !important;
`
